import * as z from 'zod'

export const NewCompanyPageSearchSchema = z.object({
  companyId: z.uuidv7().optional(),
})
